import { Grid, useMediaQuery, useTheme, Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { assignTextOnLoading, getOrderNumber } from '../../helpers/orders';
import GenDataText from '../GenDataText';
import WOrderDownloadPdfButton from './WOrderDownloadPdfButton';

const WOrderHeader = ({ data, isLoading, vendor = true, onClickDownload }) => {
  const { t } = useTranslation('workOrdersTable');
  const theme = useTheme();
  const largeScreen = useMediaQuery(theme.breakpoints.up('lg'));

  const textDirection = () => (largeScreen ? 'vertical' : null);
  const itemsAlignment = () => (largeScreen ? 'start' : 'center');

  const wOrderHeaderData = [
    {
      label: t('detail.mainData.workOrderLabel'),
      text: getOrderNumber(data?.woNumber, isLoading),
      textColor: 'primary.main',
      order: { sm: 1, lg: 1 },
    },
    {
      label: t('detail.mainData.dealershipLabel'),
      text: assignTextOnLoading(data?.dealer.name, isLoading),
      textColor: 'text.primary',
      order: { sm: 3, lg: 2 },
    },
    {
      label: t('detail.mainData.departmentLabel'),
      text: assignTextOnLoading(data?.dealer.department, isLoading),
      textColor: 'text.primary',
      order: { sm: 5, lg: 3 },
    },
    {
      label: t('detail.mainData.vendorLabel'),
      text: assignTextOnLoading(data?.vendor.rootCompanyName, isLoading),
      textColor: 'text.primary',
      order: { sm: 2, lg: 4 },
    },
    {
      label: t('detail.mainData.storeLabel'),
      text: assignTextOnLoading(
        `${data?.vendor.storeNumber} ${data?.vendor.name}`,
        isLoading
      ),
      textColor: 'text.primary',
      order: { sm: 4, lg: 5 },
    },
  ];

  const dataForVendorOrOthers = () =>
    vendor ? wOrderHeaderData : wOrderHeaderData.slice(0, -1);

  return (
    <Box p={2}>
      <Grid container gap={largeScreen ? 5 : 1}>
        {dataForVendorOrOthers().map((d, i) => (
          <Grid item key={i} xs={12} sm={6} lg="auto" order={d.order}>
            <GenDataText
              label={d.label}
              text={d.text}
              textColor={d.textColor}
              labelVariant="overline"
              labelColor="textSecondary"
              textVariant="subtitle2"
              alignItems={itemsAlignment()}
              direction={textDirection()}
            />
          </Grid>
        ))}
        <Grid
          item
          order={12}
          sx={{ marginLeft: 'auto' }}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <WOrderDownloadPdfButton onClickDownload={onClickDownload} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default WOrderHeader;
